declare const window:any;
namespace htmlCode{
    export function getTagHtml(tagName:string,resHtml:string){
        /** 根据标签名从HTML或者文本中返回标签所包含的内容
         * params:
         * 	tagName:String  例如<contianer> 
         * 	resHtml:String  ajax请求回来的HTML或者文本等
         * return:
         * 	string   标签中的内容
        */
        var html = '';
        var startIndex = 0;
        var endIndex = resHtml.length;
        var startTag = '<' + tagName + '>';
        var endTag = '</' + tagName + '>';
        //使用indexOf而不适用正则表达式，主要是因为测试时使用indexOf比正则速度快
        var _start = resHtml.indexOf(startTag);
        var _end = resHtml.lastIndexOf(endTag);
        if (_start > -1) {
            startIndex = _start;
        }
        if (_end > -1) {
            endIndex = _end;
        }
        //没有找到标签就把全部内容返回，仅警示不处理
        if(_start == -1 && _end == -1){
            console.warn('没有找到 <' + tagName + '>标签');
        }else{
            html = resHtml.substring(startIndex + startTag.length, endIndex);
        }
        return html;
    }
    export function encodeHtml(str:string){
        let s:string = "";
        if (str.length == 0) return "";
        s = str.replace(/&/g, "&amp;");
        s = s.replace(/</g, "&lt;");
        s = s.replace(/>/g, "&gt;");
        s = s.replace(/ /g, "&nbsp;");
        s = s.replace(/\'/g, "&#39;");
        s = s.replace(/\"/g, "&quot;");
        s = s.replace(/\n/g, "<br/>");
        return s;
    }
    export function getRegularHtml(data:any,str:string,_options?:any){
        //str {name}-{systemInfo.user.userName}-{objectState}-{source.id}的属性是
        data = typeof(data)=='object' ? data : {};
        const optionObj = typeof(_options)=='object' ? _options : {};
        const nullReplaceStr = optionObj.replaceNull ? optionObj.replaceNull : '';
        const isUseWorkItemState:boolean = typeof(optionObj.isUseWorkItemState)=='boolean' ? optionObj.isUseWorkItemState : false;
        const expressionData = window.NSUtils.deepCopy(data);
        if(typeof(expressionData.systemInfo)=='undefined'){
            expressionData.systemInfo = window.NetstarMainPage && typeof (window.NetstarMainPage.systemInfo) == "object" ? window.NetstarMainPage.systemInfo : {};
        }
        const tagRE:any = /\{\{((?:.|\n)+?)\}\}/g;
        const tagRE1:any = /\{((?:.|\n)+?)\}/g;
        let html:string = str;
        let matchArray:any = [];
        let workItemStateManage:any = {};
        if(window.NetStarGrid){
            workItemStateManage = window.NetStarGrid.workItemStateManage;
        }else if(typeof(window.workItemStateManageForWorkFlow)=='object'){
            workItemStateManage = window.workItemStateManageForWorkFlow;
        }
        if(tagRE.test(str)){
            matchArray = str.match(tagRE);
        }else if(tagRE1.test(str)){
            matchArray = str.match(tagRE1);
        }
        if(matchArray.length > 0){
            let expressionData:any = {};
            for(let matchI=0; matchI<matchArray.length; matchI++){
                const matchName:string = matchArray[matchI];
                const tempObj:any = window.NSUtils.getFormatParameterJSON({expField:matchName},data);
                if(matchName === '{objectState}' || matchName === '{{objectState}}'){
                    let objectStateText:any = {
                        1:'新建',
                        2:'修改',
                        3:'删除'
                    };
                    if(typeof(window.NetstarApiConfig)=='object'){
                        if(typeof(window.NetstarApiConfig.objectStateText)=='object'){
                            objectStateText = window.NetstarApiConfig.objectStateText;
                        }
                    }
                    tempObj.expField = objectStateText[tempObj.expField] ? objectStateText[tempObj.expField] : tempObj.expField;
                }else if((matchName == '{workitemState}' || matchName == '{{workitemState}}' || matchName == '{workItemState}' || matchName == '{{workItemState}}') && isUseWorkItemState){
                    let state:any = 'normal';
                    const setStateFunc = function() {
                        if (data.hasEmergency) {
                            state = 'emergency';
                        } else if (data.hasSuspend) {
                            state = 'suspend';
                        } else if (data.hasRollback) {
                            state = 'rollback';
                        }
                        //回退类型  0相当于hasRollback: false, 1和2时显示重办, 3时显示回退 sjj 20200115
                        if(typeof(data.rollbackType)=='number'){
                            if(data.rollbackType == 0){
                                state = 'normal';
                            }else if(data.rollbackType == 1 || data.rollbackType == 2){
                                state = 'rollback';
                            }else if(data.rollbackType == 3){
                                state = 'rollbackType';
                            }
                        }
                    };
                    const setStateByWorkItemStateFunc = function() {
                        if (workItemStateManage.dealt[data.workItemState]) {
                            setStateFunc();
                        } else {
                            state = workItemStateManage.name[data.workItemState];
                        }
                    };
                    if (typeof (data.workItemState) != "undefined") {
                        setStateByWorkItemStateFunc();
                    } else {
                        setStateFunc();
                    }
                    tempObj.expField = workItemStateManage.word[state] ? workItemStateManage.word[state] : '';
                }else if((matchName == '{workflowClass}' || matchName == '{{workflowClass}}') && isUseWorkItemState){
                    tempObj.expField = workItemStateManage.trtd[data['NETSTAR-MSGSTATE']] ? workItemStateManage.trtd[data['NETSTAR-MSGSTATE']] : '';
                }
                expressionData[matchName] = tempObj.expField;
                if(typeof(tempObj.expField)=='undefined'){
                    tempObj.expField = nullReplaceStr ? nullReplaceStr : '';
                }else if(typeof(tempObj.expField)=='object'){
                    if(tempObj.expField === null){
                        tempObj.expField = nullReplaceStr ? nullReplaceStr : '';
                    }else if(Object.keys(tempObj.expField).length === 0){
                        tempObj.expField = nullReplaceStr ? nullReplaceStr : '';
                    }
                }
                html = html.replace(matchName,tempObj.expField);
            }
        }
        return html;
    }//根据data数据转换string  
}
export default htmlCode;